// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"bUdkevVdFaEPqUut","actionsRow":"u9KpCTlskWYx4yNk"};